const showNetworkElementTooltip = (
  featureFlag: Boolean,
  clientSetting: Boolean,
  toolStateMode: string,
) => {
  return featureFlag && clientSetting && toolStateMode === "select";
};

export default showNetworkElementTooltip;
